module.exports = __webpack_public_path__ + "img/podigee.f5037864.svg";